export function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
}



// WEBPACK FOOTER //
// ./js/util/react.js